import { Component, ElementRef, ViewChild } from '@angular/core';
import { register } from 'swiper/element/bundle';
import { Swiper } from 'swiper';
import { ApiServiceService } from '../../services/api-service.service';
import { environment } from '../../../environments/environment.development';
import { Router } from '@angular/router';
import { SwiperOptions } from 'swiper/types';
register();

@Component({
  selector: 'app-product-banner',
  templateUrl: './product-banner.component.html',
  styleUrl: './product-banner.component.scss',
})
export class ProductBannerComponent {
  recentlyViewedProducts: any[] = [];

  userId: string = '';
  futureProductImageUrl = environment.ImageBaseUrl;
  newProductImageUrl = environment.ImageBaseUrl;
  public swiper!: Swiper;
  featuredProduct: any[] = [];
  NewProduct: any;

  @ViewChild('swiperContainer', { static: false }) swiperContainer!: ElementRef;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  swiperConfig: SwiperOptions = {
    slidesPerView: 6,
    breakpoints: {
      320: { slidesPerView: 1 },
      480: { slidesPerView: 2 },
      640: { slidesPerView: 3 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 5 },
      1200: { slidesPerView: 6 },
    },
  };
  productData: any;
  recentItem: any;

  showCaughtProduct = false;

  constructor(
    private api: ApiServiceService,
    private router: Router,
  ) {}

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollBy({
      left: -300,
      behavior: 'smooth',
    });
  }

  scrollRight() {
    this.scrollContainer.nativeElement.scrollBy({
      left: 300,
      behavior: 'smooth',
    });
  }

  ngAfterViewInit() {
    this.allActiveProducts();
  }

  getCurrentUserId(): string {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.id || ''; // Ensure this matches the field in your payload
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
    return '';
  }

  ngOnInit(): void {
    const userId = this.getCurrentUserId(); // Ensure this returns the correct userId
    this.recentProdcut(userId);
  }

  recentProdcut(userId: string) {
    if (!userId) {
      return;
    }

    this.api.getRecentlyViewedProducts(userId).subscribe({
      next: (res: any) => {
        this.recentItem = res.data;
      },
      error: () => {
        this.recentItem = [];
      },
    });
  }

  // getCurrentUserId(): string {
  //   const token = localStorage.getItem('token');
  //   if (token) {
  //     const decodedToken = JSON.parse(atob(token.split('.')[1]));
  //     return decodedToken.id; // Adjust according to your token payload
  //   }
  //   return '';
  // }

  // loadRecentlyViewedProducts(): void {
  //   this.api.getRecentlyViewed(this.userId).subscribe((data: any) => {
  //     this.recentlyViewedProducts = data.data; // Adjust according to API response
  //   });
  // }

  // addToRecentlyViewed(productId: string): void {
  //   this.api.updateRecentlyViewed(this.userId, productId).subscribe(() => {
  //     this.loadRecentlyViewedProducts(); // Refresh the list after adding
  //   });
  // }

  allActiveProducts() {
    this.api.allActiveProducts().subscribe((res: any) => {
      this.productData = res;
      this.featuredProduct = this.productData.filter(
        (product: any) => product.isFeatured === true,
      );
      this.NewProduct = this.productData.filter(
        (product: any) => product.isNewProduct === true,
      );
    });
  }

  getProductById(id: any) {
    this.router.navigate(['product-details', id]);
  }

  initializeSwiper() {
    const swiperEl = this.swiperContainer?.nativeElement as any;
    if (!swiperEl) {
      return;
    }
    Object.assign(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 7,
        },
      },
    });
    swiperEl.initialize();
  }

  newProductList() {
    this.router.navigate(['product-list'], { state: this.NewProduct });
  }
  featureProductList() {
    this.router.navigate(['product-list'], { state: this.featuredProduct });
  }
}
